var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMylogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8582 27.501C35.3632 27.501 31.7193 31.1482 31.7193 35.6476C31.7193 40.1469 35.3632 43.7941 39.8582 43.7941C44.3532 43.7941 47.9971 40.1468 47.9971 35.6476C47.9971 31.1483 44.3532 27.501 39.8582 27.501ZM39.8582 39.781C37.5774 39.781 35.7286 37.9303 35.7286 35.6476C35.7286 33.3648 37.5774 31.5141 39.8582 31.5141C42.1389 31.5141 43.9878 33.3646 43.9878 35.6476C43.9878 37.9305 42.1388 39.781 39.8582 39.781Z",
    fill: "#4F6382",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7839 27.5068V33.6469H19.7782V37.6599H23.7839V43.8H27.7932V27.5068H23.7839Z",
    fill: "#4F6382",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1525 38.2485L10.1389 30.2273L2.12524 38.2485L4.96035 41.0862L10.1389 35.9027L15.3176 41.0862L18.1525 38.2485Z",
    fill: "#4F6382",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7315 19.28V7H31.7222V23.2931H35.7315H48V19.28H35.7315Z",
    fill: "#4F6382",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7931 7H23.7838V23.2931H27.7931V7Z",
    fill: "#4F6382",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1389 7C5.64392 7 2 10.6474 2 15.1466C2 19.6458 5.64392 23.2931 10.1389 23.2931C14.6338 23.2931 18.2777 19.6458 18.2777 15.1466C18.2777 10.6474 14.6338 7 10.1389 7ZM10.1389 19.28C7.85812 19.28 6.0093 17.4295 6.0093 15.1466C6.0093 12.8637 7.85812 11.0131 10.1389 11.0131C12.4196 11.0131 14.2685 12.8637 14.2685 15.1466C14.2685 17.4295 12.4196 19.28 10.1389 19.28Z",
    fill: "#4F6382",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMylogo);
export default __webpack_public_path__ + "static/media/mylogo.7e09df98e2a00d9530dc23f8346c4289.svg";
export { ForwardRef as ReactComponent };